import { render, staticRenderFns } from "./PackageOrders.vue?vue&type=template&id=1ced09b2"
import script from "./PackageOrders.vue?vue&type=script&lang=js"
export * from "./PackageOrders.vue?vue&type=script&lang=js"
import style0 from "./PackageOrders.vue?vue&type=style&index=0&id=1ced09b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports